import React from "react";

const AboutTimeLineSection = ({ data }) => (

    <section className="about-section">

        <div className="about-container">

            {/* =================================================
                 HEADER
            ================================================== */}

            <div className="about-center">

                <div className="about-eyebrow">
                    {data.eyebrow}
                </div>

                <h2 className="about-title">
                    {data.title}
                    {data.highlight && (
                        <span>{data.highlight}</span>
                    )}
                </h2>

                <p className="about-text">
                    {data.description}
                </p>

            </div>


            {/* =================================================
                 TIMELINE
            ================================================== */}

            {data.timeline?.length > 0 && (
                <div className="about-timeline">

                    {data.timeline.map((item, i) => (

                        <div
                            className="timeline-item"
                            key={item.year || i}
                        >

                            <div className="timeline-year">
                                {item.year}
                            </div>

                            <div className="timeline-content">

                                {item.title && (
                                    <h3>
                                        {item.title}
                                    </h3>
                                )}

                                {(item.paragraphs || []).map(
                                    (paragraph, j) => (
                                        <p key={j}>
                                            {paragraph}
                                        </p>
                                    )
                                )}

                            </div>

                        </div>

                    ))}

                </div>
            )}

        </div>

    </section>
);

export default AboutTimeLineSection;